import React, { useId } from "react";
import { IconButton, Tooltip } from "@commonsku/design-system";
import { ShowPopup } from "@commonsku/styles";
import { Plus } from "lucide-react";
import NewProjectPopup from "../project/NewProjectPopup";

const NewProjectButton = () => {
    const triggerId = useId();

    return (
        <ShowPopup
            popup={NewProjectPopup}
            autoOpen={false}
            render={({ onClick }) => (
                <Tooltip.Root
                    ids={{ trigger: triggerId }}
                    positioning={{
                        placement: "bottom-end",
                        strategy: "fixed",
                    }}
                >
                    <Tooltip.Trigger asChild>
                        <IconButton
                            label="create a new project"
                            size="sm"
                            variant="outline"
                            colorPalette="neutral"
                            rounded="md"
                            onClick={onClick}
                        >
                            <Plus size={18} aria-hidden="true" />
                        </IconButton>
                    </Tooltip.Trigger>
                    <Tooltip.Positioner>
                        <Tooltip.Content>Create a new project</Tooltip.Content>
                    </Tooltip.Positioner>
                </Tooltip.Root>
            )}
        />
    );
};

export default NewProjectButton;
